import { CdAutocompleteData } from './cd-autocomplete-data.model';

export class CdAutocomplete {
  changeTrigger = false;
  data?: CdAutocompleteData[];
  list?: any[];
}
